/**
 * @module line/lineediting
 */

import { Plugin } from 'ckeditor5/src/core';
import LineCommand from './linecommand';

/**
 * The abstract line editing plugin.
 *
 * @extends Plugin
 */
export default class LineEditing extends Plugin {

	/**
	 * Defines the values to be used
	 *
	 * @param {Editor} editor
	 * @param {String} attributeKey
	 * @param {String} defaultValue
	 * @param {String} defaultTitle
	 * @param {String} tooltip
	 * @param {Array<String>} options
	 */
	constructor( editor, attributekey, defaultValue, viewKey, options ) {
		super( editor );
		/**
		 * @private
		 * @type {String}
		 */
		this.attributekey = attributekey;
		/**
		 * @private
		 * @type {String}
		 */
		this.defaultValue = defaultValue;
		/**
		 * @private
		 * @type {String}
		 */
		this.viewKey = viewKey;

		editor.config.define( attributekey, {
			options
		} );
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const schema = editor.model.schema;
		const options = editor.config.get( `${ this.attributekey }.options` );

		schema.extend( '$block', {
			allowAttributes: this.attributekey
		} );
		schema.setAttributeProperties( this.attributekey, {
			isFormatting: true,
			copyOnEnter: true
		} );

		const definition = _buildDefinition( this.attributekey, this.viewKey, options.filter( option => option !== this.defaultValue ) );

		editor.conversion.attributeToAttribute( definition );

		editor.commands.add( this.attributekey, new LineCommand( editor, this.attributekey, this.defaultValue ) );
	}
}

// Utility function responsible for building converter definition.
// @private
function _buildDefinition( attributekey, viewKey, options ) {
	const definition = {
		model: {
			key: attributekey,
			values: options.slice()
		},
		view: {}
	};

	for ( const option of options ) {
		definition.view[ option ] = {
			key: 'style',
			value: {}
		};
		if ( Array.isArray( viewKey ) ) {
			viewKey.forEach( key => {
				definition.view[ option ].value[ key ] = option;
			} )
		} else {
			definition.view[ option ].value[ viewKey ] = option;
		}
	}

	return definition;
}
